import {FUIFormContext} from "./form-context";
import {Injectable} from "@angular/core";
import {FUIContextType} from "./form-context-type";

/**
 * Context for controls being used in a grid column header. These controls are typically more compact.
 */
@Injectable()
export class FUIHeaderFormContext extends FUIFormContext {
    constructor() {
        super(FUIContextType.HEADER, "Header");
    }
}
